module.exports = __webpack_public_path__ + "img/MEDIA032.1c00e824.jpg";